import { PreviousSalaryDTO } from '@Models/model.types';
import { getContextId } from '@tlx/astro-shared';
import { AttachmentIcon, Button } from '@tlx/atlas';
import { useTskContext } from '@Hooks/useTskContext.ts';
import { useIntl } from 'react-intl';
import { previewVoucher } from '@Util/links.ts';

export function SalariesInPeriod({ salaries }: { salaries: PreviousSalaryDTO[] | undefined }) {
    const contextId = getContextId();

    if (!salaries || salaries.length === 0) {
        return <>-</>;
    }

    // Need this wrapper div because of some alignment issue if adding atl-flex-col to Cell
    return (
        <div className={'atl-flex atl-flex-col atl-w-full'}>
            {salaries.map((salary) => (
                <SalariesInPeriodDisplay
                    salary={salary}
                    contextId={parseInt(contextId ?? '0')}
                    key={salary.salaryTransactionId}
                />
            ))}
        </div>
    );
}

const getSalaryRedirectUrlForEmployee = (salary: PreviousSalaryDTO, contextId: number, isPilotSalaryRun?: boolean) => {
    if (!isPilotSalaryRun) {
        return `/execute/wageTransactionMenu?wageTransactionId=${salary.salaryTransactionId}&contextId=${contextId}`;
    }
    return `/execute/salary?salaryTransactionId=${salary.salaryTransactionId}&selectedPaymentId=${salary.wagePaymentIdOfEmployee}&contextId=${contextId}`;
};

type Props = {
    salary: PreviousSalaryDTO;
    contextId: number;
};

export function SalariesInPeriodDisplay({ salary, contextId }: Props) {
    const { isPilotSalaryRun } = useTskContext();
    const intl = useIntl();
    if (salary.isAccessibleToLoggedInUser) {
        return (
            <div className={'atl-flex atl-items-center atl-w-full atl-justify-between atl-truncate'}>
                <a href={getSalaryRedirectUrlForEmployee(salary, contextId, isPilotSalaryRun)}>{salary.displayName}</a>
                <Button
                    variant={'icon'}
                    className={'atl-p-0 tsk-small-button'}
                    data-testid={'view-salary-voucher-' + salary.salaryTransactionId}
                    aria-label={intl.formatMessage({
                        id: 'text_view_preview_voucher',
                    })}
                    onClick={() => {
                        previewVoucher(salary.salaryTransactionId, contextId ?? 0);
                    }}
                >
                    <AttachmentIcon data-testid={'preview-salary-voucher-' + salary.salaryTransactionId} />
                </Button>
            </div>
        );
    } else {
        return <>{salary.displayName}</>;
    }
}
